import { useState, useEffect } from 'react';
import Select from 'react-select';
import { _single } from '../../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
}

export const SelectIDContractSingleton = ({ idSelector, onChange, label, returnType = "ID" }: Props) => {
    const lista = _single.getMyEmployeeContract();
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.IDContract === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.IDContract,
                    label: `${found.FunctionalIDName} - ${found.FunctionalAreaName}`,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.IDContract,
        label: `${item.FunctionalIDName} - ${item.FunctionalAreaName}`,
        item: item
    }));

    return (
        <div>
            {label !== " " && (
                <label>{label || "Contratos Disponibles"}</label>
            )}
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona un Contrato..."
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div >
    );
};
